export type Direction = "ltr" | "rtl";

// Languages that render right-to-left. Add "fa", "ur" here as they're enabled.
export const RTL_LOCALES = new Set(["ar", "he"]);

export function getDirection(lang?: string | null): Direction {
  return lang && RTL_LOCALES.has(lang.split("-")[0]) ? "rtl" : "ltr";
}
